import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Tamaño de página',
	PageOrientation: 'Orientación de página',
	Format: 'Formato',
	DPI: 'DPI',
	Generate: 'Generar',
	LanguageName: 'Española',
	LanguageCode: 'es'
};

export default translation;
